var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:{ fixed_header: !_vm.fixedHeader },attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',_vm._l((_vm.head),function(item){return _c('th',{key:item,attrs:{"scope":"col"}},[_vm._v(_vm._s(item))])}),0)]),_c('tbody',[_vm._t("table-body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }